<template>
  <div class="login-page">
    <!-- 背景装饰圆 -->
    <div class="bg-decoration">
      <div class="circle circle-1"></div>
      <div class="circle circle-2"></div>
      <div class="circle circle-3"></div>
    </div>

    <!-- 登录卡片 -->
    <div class="login-card">
      <!-- Logo 区域 -->
      <div class="brand-area">
        <div class="logo-icon">
          <span>恒</span>
        </div>
        <h1 class="brand-name">恒鑫分期</h1>
        <p class="brand-desc">专业分期服务平台</p>
      </div>

      <!-- 表单区域 -->
      <div class="form-area">
        <!-- 账户 -->
        <div class="input-group">
          <div class="input-icon">
            <nut-icon name="my" size="18" color="#8B7355"></nut-icon>
          </div>
          <input
            class="custom-input"
            type="text"
            placeholder="请输入账户"
            v-model="loginForm.account"
            autocomplete="username"
          />
        </div>

        <!-- 密码 -->
        <div class="input-group">
          <div class="input-icon">
			<svg t="1782717515325" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7773" width="18" height="18">
				<path fill="#8B7355" d="M259.64544 457.44128l504.7296 0c20.35712 0 38.44096 8.2944 51.99872 21.83168 13.57824 13.57824 21.83168 31.66208 21.83168 52.0192l0 342.75328c0 19.5584-8.25344 38.42048-21.83168 51.97824l0 0c-13.55776 12.8-31.6416 21.07392-51.99872 21.07392L259.64544 947.0976c-20.33664 0-39.19872-8.27392-51.99872-21.07392-13.57824-13.55776-21.83168-31.66208-21.83168-51.97824L185.81504 531.29216c0-20.35712 8.27392-38.44096 21.83168-52.0192l0 0 0 0C221.20448 465.75616 239.3088 457.44128 259.64544 457.44128L259.64544 457.44128zM764.35456 497.39776 259.64544 497.39776c-9.80992 0-18.08384 3.72736-24.12544 9.76896l0 0c-6.02112 6.0416-9.78944 15.09376-9.78944 24.14592l0 342.75328c0 9.0112 3.76832 17.32608 9.78944 23.36768 6.0416 6.02112 15.07328 9.78944 24.12544 9.78944l504.7296 0c9.05216 0 17.36704-3.76832 24.12544-9.78944l0 0c6.06208-6.0416 9.80992-14.336 9.80992-23.36768L798.3104 531.29216c0-9.03168-3.76832-18.10432-9.80992-24.14592C781.7216 501.12512 773.4272 497.39776 764.35456 497.39776L764.35456 497.39776z" p-id="7774"></path>
				<path fill="#8B7355" d="M753.07008 351.21152c0 10.5472-9.05216 19.59936-20.35712 19.59936-11.28448 0-19.53792-9.05216-19.53792-19.59936 0-55.74656-22.60992-106.20928-58.75712-142.37696-36.94592-36.1472-86.67136-58.75712-142.39744-58.75712-55.76704 0-106.22976 22.60992-142.39744 58.75712-36.16768 36.16768-58.75712 86.6304-58.75712 142.37696l0 118.272c0 10.5472-9.05216 19.59936-19.59936 19.59936-11.28448 0-20.33664-9.03168-20.33664-19.59936l0-118.272c0-66.29376 27.11552-126.5664 70.79936-170.25024 43.7248-43.68384 103.97696-70.81984 170.2912-70.81984 66.29376 0 126.5664 27.11552 170.27072 70.81984C725.95456 224.6656 753.07008 284.93824 753.07008 351.21152L753.07008 351.21152z" p-id="7775"></path>
			</svg>
            <!-- <nut-icon name="lock" size="18" color="#8B7355"></nut-icon> -->
          </div>
          <input
            class="custom-input"
            :type="showPwd ? 'text' : 'password'"
            placeholder="请输入密码"
            v-model="loginForm.password"
            autocomplete="current-password"
          />
          <div class="input-suffix" @click="showPwd = !showPwd">
            <nut-icon :name="showPwd ? 'eye' : 'photograph'" size="16" color="#999"></nut-icon>
          </div>
        </div>

        <!-- 验证码 -->
        <div class="input-group">
          <div class="input-icon">
            <nut-icon name="image" size="18" color="#8B7355"></nut-icon>
          </div>
          <input
            class="custom-input"
            type="text"
            placeholder="请输入验证码"
            v-model="loginForm.code"
            maxlength="4"
            style="flex: 1; max-width: 55%;"
          />
          <div class="captcha-box" @click="getCaptcha" title="点击刷新验证码">
            <img v-if="captchaImg" :src="captchaImg" alt="验证码" class="captcha-img" />
            <span v-else class="captcha-placeholder">加载中…</span>
          </div>
        </div>

        <!-- 记住密码 -->
        <div class="options-row">
          <label class="remember-label" @click="rememberMe = !rememberMe">
            <span class="check-box" :class="{ checked: rememberMe }">
              <nut-icon v-if="rememberMe" name="checklist" size="12" color="#fff"></nut-icon>
            </span>
            <span>记住密码</span>
          </label>
          <span class="forgot-link" @click="handleForgot">忘记密码？</span>
        </div>

        <!-- 登录按钮 -->
        <button
          class="login-btn"
          :class="{ loading: loading }"
          :disabled="loading"
          @click="handleLogin"
        >
          <span v-if="!loading">登 录</span>
          <span v-else class="btn-loading">
            <i class="loading-spinner"></i> 登录中…
          </span>
        </button>

        <!-- 底部提示 -->
        <p class="footer-tip">首次使用请联系管理员开通账户</p>
      </div>
    </div>
	<div class="footer-copy"><span>©2026 恒鑫智慧（上海）科技有限公司 版权所有 <a class="footer-a" target="_blank" href="https://beian.miit.gov.cn/">沪ICP备2026031177号</a></span></div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, getCurrentInstance } from 'vue';
import { Toast } from '@nutui/nutui';

const { proxy } = getCurrentInstance();

// 表单数据
const loginForm = reactive({
  account: '',
  password: '',
  code: ''
});

// 状态变量
const captchaImg = ref('');
const rememberMe = ref(false);
const loading = ref(false);
const uuid = ref('');
const showPwd = ref(false);

const showToast = (msg) => {
  Toast.text(msg);
};

// 获取验证码
const getCaptcha = () => {
  proxy.$axios.getCodeImg().then(res => {
    if (res.data.code == 200) {
      captchaImg.value = 'data:image/gif;base64,' + res.data.img;
      uuid.value = res.data.uuid;
    }
  });
};

// 忘记密码
const handleForgot = () => {
  showToast('请联系管理员重置密码');
};

// 处理登录逻辑
const handleLogin = () => {
  if (!loginForm.account) {
    showToast('请输入账户');
    return;
  }
  if (!loginForm.password) {
    showToast('请输入密码');
    return;
  }
  if (!loginForm.code) {
    showToast('请输入验证码');
    return;
  }

  loading.value = true;

  const params = {
    username: loginForm.account,
    password: loginForm.password,
    code: loginForm.code,
    uuid: uuid.value
  };

  proxy.$axios.login(params).then(res => {
    loading.value = false;
    if (res.data.code === 200) {
      localStorage.setItem('token', res.data.data.access_token);
      if (rememberMe.value) {
        localStorage.setItem('rememberInfo', JSON.stringify({
          account: loginForm.account,
          password: loginForm.password
        }));
      } else {
        localStorage.removeItem('rememberInfo');
      }
      proxy.$axios.getInfo().then(res => {
        if (res.data.code === 200) {
          localStorage.setItem('user', JSON.stringify(res.data.user));
          proxy.$router.push('/');
        }
      });
    } else {
      getCaptcha();
    }
  }).catch(() => {
    loading.value = false;
    showToast('网络异常，请稍后重试');
    getCaptcha();
  });
};

// 页面初始化
onMounted(() => {
  getCaptcha();
  const savedInfo = localStorage.getItem('rememberInfo');
  if (savedInfo) {
    try {
      const { account, password } = JSON.parse(savedInfo);
      loginForm.account = account;
      loginForm.password = password;
      rememberMe.value = true;
    } catch (e) {
      // ignore
    }
  }
});
</script>

<style scoped>
/* ========== 页面整体 ========== */
.login-page {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(160deg, #f0ebe3 0%, #e8ddd0 30%, #d4c5b2 60%, #c5b69a 100%);
  overflow: hidden;
  padding: 20px;
  box-sizing: border-box;
}

/* ========== 背景装饰圆 ========== */
.bg-decoration {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
}
.circle {
  position: absolute;
  border-radius: 50%;
  opacity: 0.12;
}
.circle-1 {
  width: 350px;
  height: 350px;
  background: #8B7355;
  top: -120px;
  right: -80px;
  animation: float 8s ease-in-out infinite;
}
.circle-2 {
  width: 220px;
  height: 220px;
  background: #C5A47E;
  bottom: -60px;
  left: -60px;
  animation: float 6s ease-in-out 1s infinite;
}
.circle-3 {
  width: 180px;
  height: 180px;
  background: #8B7355;
  top: 40%;
  left: -40px;
  animation: float 7s ease-in-out 2s infinite;
}
@keyframes float {
  0%, 100% { transform: translateY(0) scale(1); }
  50% { transform: translateY(-20px) scale(1.05); }
}

/* ========== 登录卡片 ========== */
.login-card {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 400px;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: 20px;
  box-shadow:
    0 20px 60px rgba(0, 0, 0, 0.08),
    0 4px 16px rgba(139, 115, 85, 0.1);
  padding: 40px 32px 36px;
  transform: scale(0.8) translateY(-8%);
  transform-origin: center center;
  animation: cardIn 0.6s ease-out;
}
@keyframes cardIn {
  from {
    opacity: 0;
    transform: scale(0.8) translateY(-5%);
  }
  to {
    opacity: 1;
    transform: scale(0.8) translateY(-8%);
  }
}

/* ========== 品牌区域 ========== */
.brand-area {
  text-align: center;
  margin-bottom: 32px;
}
.logo-icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 14px;
  background: linear-gradient(135deg, #8B7355, #C5A47E);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 20px rgba(139, 115, 85, 0.3);
}
.logo-icon span {
  font-size: 26px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 1px;
}
.brand-name {
  font-size: 22px;
  font-weight: 700;
  color: #3a3226;
  margin: 0 0 6px;
  letter-spacing: 2px;
}
.brand-desc {
  font-size: 13px;
  color: #8B7355;
  margin: 0;
  letter-spacing: 1px;
}

/* ========== 输入框组 ========== */
.form-area {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.input-group {
  display: flex;
  align-items: center;
  background: #f8f6f3;
  border: 1.5px solid transparent;
  border-radius: 12px;
  padding: 0 14px;
  height: 48px;
  transition: all 0.3s ease;
}
.input-group:focus-within {
  border-color: #C5A47E;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(197, 164, 126, 0.1);
}
.input-icon {
  display: flex;
  align-items: center;
  margin-right: 10px;
  flex-shrink: 0;
}
.custom-input {
  flex: 1;
  height: 100%;
  border: none;
  outline: none;
  background: transparent;
  font-size: 15px;
  color: #333;
  font-family: inherit;
}
.custom-input::placeholder {
  color: #bfbfbf;
  font-size: 14px;
}
.input-suffix {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 4px;
  flex-shrink: 0;
}

/* ========== 验证码 ========== */
.captcha-box {
  flex-shrink: 0;
  margin-left: 8px;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid #e8e5e0;
  height: 38px;
  transition: transform 0.2s ease;
}
.captcha-box:active {
  transform: scale(0.95);
}
.captcha-img {
  display: block;
  height: 38px;
  min-width: 90px;
}
.captcha-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 38px;
  width: 90px;
  font-size: 12px;
  color: #999;
  background: #f0ede8;
}

/* ========== 选项行 ========== */
.options-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2px 2px;
}
.remember-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #666;
  cursor: pointer;
  user-select: none;
}
.check-box {
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: 1.5px solid #d0cbc4;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.25s ease;
}
.check-box.checked {
  background: #8B7355;
  border-color: #8B7355;
}
.forgot-link {
  font-size: 13px;
  color: #8B7355;
  cursor: pointer;
  transition: color 0.2s;
}
.forgot-link:hover {
  color: #6b5a42;
}

/* ========== 登录按钮 ========== */
.login-btn {
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 24px;
  background: linear-gradient(135deg, #8B7355, #a89070);
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 6px 20px rgba(139, 115, 85, 0.3);
  margin-top: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 25px rgba(139, 115, 85, 0.4);
}
.login-btn:active {
  transform: translateY(0);
  box-shadow: 0 4px 12px rgba(139, 115, 85, 0.3);
}
.login-btn:disabled {
  cursor: not-allowed;
  opacity: 0.8;
}
.login-btn.loading {
  background: linear-gradient(135deg, #9e8b75, #b5a090);
}

/* 按钮加载动画 */
.btn-loading {
  display: flex;
  align-items: center;
  gap: 8px;
}
.loading-spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}
@keyframes spin {
  to { transform: rotate(360deg); }
}

/* ========== 底部提示 ========== */
.footer-tip {
  text-align: center;
  font-size: 12px;
  color: #bbb;
  margin: 10px 0 0;
  letter-spacing: 0.5px;
}
.footer-copy{
	position: fixed;
	bottom: 20px;
	font-size: 12px;
	color: #fff;
}
.footer-a{
	text-decoration: none;
	color: #fff;
}
.footer-a:hover{
	color: #a89070;
}
</style>
